var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { logger } from "../logger";
import { EventFactory } from "./EventFactory";
/**
 * A service to generate valid event payloads and queue them for processing
 */
var EventManager = /** @class */ (function () {
    /**
     *
     * @param eventQueue Event queue instance
     */
    function EventManager(eventQueue) {
        this.eventQueue = eventQueue;
        this.eventFactory = new EventFactory();
    }
    /**
     * Consumes a new incoming event
     * @param event Incoming event data
     */
    EventManager.prototype.addEvent = function (event, address, userId) {
        var callback = event.callback, _event = __rest(event, ["callback"]);
        var formoEvent = this.eventFactory.create(_event, address, userId);
        this.eventQueue.enqueue(formoEvent, function (err, _, data) {
            if (err) {
                logger.error("Error sending events:", err);
            }
            else
                logger.info("Events sent successfully: ".concat(data.length, " events"));
            callback === null || callback === void 0 ? void 0 : callback(err, _, data);
        });
    };
    return EventManager;
}());
export { EventManager };
//# sourceMappingURL=EventManager.js.map